export default "__VITE_ASSET__lE10XdKi__"